// Met à jour le lien de nav actif selon la section affichée (scrollspy).
// Le scroll fluide + le décalage sous le header sont gérés en CSS
// (scroll-behavior / scroll-padding-top) ; ici on ne fait que marquer l'actif.
export function initNav() {
  const links = Array.from(document.querySelectorAll(".c-header__link")).filter(
    (a) => (a.getAttribute("href") || "").startsWith("#"),
  );
  if (!links.length) return;

  // Apparie chaque lien à sa section (dans l'ordre du document).
  const pairs = links
    .map((link) => {
      const section = document.getElementById(link.getAttribute("href").slice(1));
      return section ? { link, section } : null;
    })
    .filter(Boolean);
  if (!pairs.length) return;

  const sections = pairs.map((p) => p.section);
  const linkFor = new Map(pairs.map((p) => [p.section, p.link]));

  const setActive = (active) => {
    for (const { link } of pairs) {
      if (link === active) link.setAttribute("aria-current", "true");
      else link.removeAttribute("aria-current");
    }
  };

  // Marquage immédiat au clic (avant l'arrivée du scroll fluide).
  for (const { link, section } of pairs) {
    link.addEventListener("click", () => setActive(linkFor.get(section)));
  }

  // La section visible la plus haute (juste sous le header) devient active.
  const headerHeight = document.querySelector(".c-header")?.offsetHeight ?? 0;
  const visible = new Set();
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      }
      const current = sections.find((section) => visible.has(section));
      if (current) setActive(linkFor.get(current));
    },
    { rootMargin: `-${headerHeight + 1}px 0px -60% 0px`, threshold: 0 },
  );

  for (const section of sections) observer.observe(section);
}
